module.exports = __webpack_public_path__ + "static/media/buustikasino.0c525905.png";